import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GlobleSettingsService {

  public isHeader = false;
  public isFooter = false;
  public isLogo = false;
  public isSelected = '';
  public showLoader = false;
  public firstTimeLoad = true;
  public deviceData;
  public isBrowserDevice = true;
  public isdisabled = true;
  public AppVirsion  = '1.0.17';

  public videoList = [];

  constructor(public http: HttpClient) {
    this.videoList= [

      {
        expanded: false,
        title: "Sleep Apnea Treatment",
        videos: [
          { id: 1, image: './assets/player-thumbnails/sleep_apnea_treatment/consequences.svg', title: 'Consequences of Untreated Sleep Apnea', file: './assets/playlists/sleep_apnea _treatment/Consequences_of_Untreated_Sleep_Apnea.mp4', selected: false },
          { id: 2, image: './assets/player-thumbnails/sleep_apnea_treatment/treatment-options.svg', title: 'Sleep Apnea Treatment Options', file: './assets/playlists/sleep_apnea _treatment/Sleep_Apnea_Treatment_Options.mp4', selected: false }
        ]
      },
      {
        expanded: false,
        title: "Learning About Inspire",
        videos: [
          { id: 3, image: './assets/player-thumbnails/learning_about_inspire/howinspireworks.svg', title: 'How Does Inspire Work ?', file: './assets/playlists/learning_about_inspire/How_Inspire_Works.mp4', selected: true },
          { id: 4, image: './assets/player-thumbnails/learning_about_inspire/willinspireworkforyou.svg', title: 'Will Inspire Work For You?', file: './assets/playlists/learning_about_inspire/Will_Inspire_Work_for_You.mp4', selected: false },
          { id: 5, image: './assets/player-thumbnails/learning_about_inspire/stepstogetinspire.svg', title: 'Steps to Get Inspire', file: './assets/playlists/learning_about_inspire/Steps_To_Get_Inspire.mp4', selected: false }
        ]
      },
      {
        expanded: false,
        title: "Appointment Preparation",
        videos: [
          { id: 6, image: './assets/player-thumbnails/appointment_preparation/prepareforappointment.svg', title: 'How To Prepare For Your Appointment', file: './assets/playlists/preparing_for_your_appointment/How_To_Prepare_For_Your_Appointment.mp4', selected: false }
        ]
      },
      {
        expanded: false,
        title: "Common Questions",
        videos: [
          { id: 7, image: './assets/player-thumbnails/common_questions/howmuchcost.svg', title: 'How Much Does Inspire Cost', file: './assets/playlists/common_questions/How_Much_Does_Inspire_Cost.mp4', selected: false },
          { id: 8, image: './assets/player-thumbnails/common_questions/whatdoesinspirefeellike.svg', title: 'What Does Inspire Feel Like', file: './assets/playlists/common_questions/What_Does_Inspire_Feel_Like.mp4', selected: false },
          { id: 9, image: './assets/player-thumbnails/common_questions/willinspirelimitactivities.svg', title: 'Will Inspire Limit My Activities', file: './assets/playlists/common_questions/Will_Inspire_Limit_My_Activities.mp4', selected: false }
        ]
      },
      {
        expanded: false,
        title: "Getting Inspire",
        videos: [
          { id: 10, image: './assets/player-thumbnails/getting_inspire/airwayexam.svg', title: 'Airway Exam', file: './assets/playlists/getting_inspire/Airway_Exam.mp4', selected: false },
          { id: 11, image: './assets/player-thumbnails/getting_inspire/inspireprocedure.svg', title: 'Inspire Procedure', file: './assets/playlists/getting_inspire/Inspire_Procedure.mp4', selected: false }
        ]
      },
      {
        expanded: false,
        title: "Inspire Lives",
        videos: [
          { id: 12, image: './assets/player-thumbnails/inspire_lives/alan.svg', title: 'Alan', file: './assets/playlists/inspire_lives/Alan.mp4', selected: false },
          { id: 13, image: './assets/player-thumbnails/inspire_lives/brian.svg', title: 'Brian', file: './assets/playlists/inspire_lives/Brian.mp4', selected: false },
          { id: 14, image: './assets/player-thumbnails/inspire_lives/diane.svg', title: 'Diane', file: './assets/playlists/inspire_lives/Diane.mp4', selected: false },
          { id: 15, image: './assets/player-thumbnails/inspire_lives/ellen.svg', title: 'Ellen', file: './assets/playlists/inspire_lives/Ellen.mp4', selected: false },
          { id: 16, image: './assets/player-thumbnails/inspire_lives/james.svg', title: 'James', file: './assets/playlists/inspire_lives/James.mp4', selected: false },
          { id: 17, image: './assets/player-thumbnails/inspire_lives/jamesfarhana.svg', title: 'James and Farhana', file: './assets/playlists/inspire_lives/James_and_Farhana.mp4', selected: false },
          { id: 18, image: './assets/player-thumbnails/inspire_lives/karen.svg', title: 'Karen', file: './assets/playlists/inspire_lives/Karen.mp4', selected: false },
          { id: 19, image: './assets/player-thumbnails/inspire_lives/laurie.svg', title: 'Laurie', file: './assets/playlists/inspire_lives/Laurie_and_Jefft.mp4', selected: false },
          { id: 20, image: './assets/player-thumbnails/inspire_lives/lauriejeff.svg', title: 'Laurie and Jeff', file: './assets/playlists/inspire_lives/Laurie.mp4', selected: false },
          { id: 21, image: './assets/player-thumbnails/inspire_lives/lottie.svg', title: 'Lottie', file: './assets/playlists/inspire_lives/Lottie.mp4', selected: false },
          { id: 22, image: './assets/player-thumbnails/inspire_lives/relationship_impact.svg', title: 'Relationship Impact', file: './assets/playlists/inspire_lives/Relationship_Impact.mp4', selected: false },
          { id: 23, image: './assets/player-thumbnails/inspire_lives/alan.svg', title: 'Sandi', file: './assets/playlists/inspire_lives/Sandi.mp4', selected: false },
          { id: 24, image: './assets/player-thumbnails/inspire_lives/stephen.svg', title: 'Stephen', file: './assets/playlists/inspire_lives/Stephen.mp4', selected: false }
        ]
      },
      {
        expanded: false,
        title: "Inspire Care",
        videos: [
          { id: 25, image: './assets/player-thumbnails/inspire_care/welcome.svg', title: 'Welcome to the Inspire Family', file: './assets/playlists/inspire_care/Welcome_To_The_Inspire_Community.mp4', selected: false },
          { id: 26, image: './assets/player-thumbnails/inspire_care/rest_and_heal.svg', title: 'Rest and Heal', file: './assets/playlists/inspire_care/Rest_and_Heal.mp4', selected: false },
          { id: 27, image: './assets/player-thumbnails/inspire_care/learning_remote.svg', title: 'Learn Your Sleep Remote', file: './assets/playlists/inspire_care/Learning_Your_Inspire_Remote.mp4', selected: false },
          { id: 28, image: './assets/player-thumbnails/inspire_care/connecting_to_the_inspire_app.svg', title: 'Connecting to the Inspire App', file: './assets/playlists/inspire_care/Connecting_Inspire_App.mp4', selected: false },
          { id: 29, image: './assets/player-thumbnails/inspire_care/tuning_inspire.svg', title: 'Tuning Inspire', file: './assets/playlists/inspire_care/Tuning_Inspire.mp4', selected: false },
          { id: 30, image: './assets/player-thumbnails/inspire_care/life_with_inspire.svg', title: 'Life with Inspire', file: './assets/playlists/inspire_care/Will_Inspire_Limit_My_Activities.mp4', selected: false }
        ]
      }
    ];
  }

  updateAnalytics(data) {

    // Web Site Hide
    if(!this.isBrowserDevice){
      const headers = new HttpHeaders();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json' );
      const options =  ({
        headers: headers
      });

      this.http.post("https://www.register-inspire.com/api.php", data, options)
      .subscribe(data => {
        console.log(data);
      }, error => {
        console.log(error);
      });
    }
  }

  updateDeviceInfo(deviceDatas) {

    var locationLatitude = this.deviceData['locationLatitude'];
    var locationLongitude = this.deviceData['locationLongitude'];
    var ssid = this.deviceData['ssid'];
    var batteryLevel = this.deviceData['batteryLevel'];
    var plugged = this.deviceData['plugged'];
    var userData = JSON.parse(localStorage.getItem('currentUser'));
      var deviceData = {
        "battery":batteryLevel,
        "power":plugged,
        "status":"1",
      //  "ip_address":"108.162.219.168",
        "app_version": this.AppVirsion,
        "device_id":userData.deviceid,
        "latitude":locationLatitude,
        "longitude":locationLongitude,
        "ssid":ssid,
        "act":"update_device"
      }

      const headers = new HttpHeaders();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json' );
      const options =  ({
        headers: headers
      });

      this.http.post("https://www.register-inspire.com/api.php", deviceData, options)
      .subscribe(data => {
        console.log(data);
      }, error => {
        console.log(error);
      });
  }


  getDeviceInfo(){
    var deviceInfoUrl = 'http://localhost:2424/?cmd=deviceInfo&password=sunshineinparis&type=json';
    console.log(deviceInfoUrl);
    const headers = new HttpHeaders();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    const options =  ({
      headers: headers
    });

    this.http.get(deviceInfoUrl, options).subscribe(data => {
      this.deviceData = data;
      console.log(this.deviceData);
      this.updateDeviceInfo(this.deviceData);
      //this.deviceInfoForm
      }, error => {
      console.log(error);
    });
  }
}
